import { IconProps } from './types';

const TrainingAgentPinIcon = (props: IconProps) => {
  const {
    width = '50',
    height = '67',
    fillColor = 'var( --navi-location-pin-border)',
    fillColor1 = 'var(--navi-location-pin-bg)',
    fillColor2 = 'var(--navi-location-pin-base)',
    strokeColor = 'var(--navi-color-violet-base)'
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ddd_6677_63891)">
        <path
          d="M37 28C37 37.3888 20 62.1621 20 62.1621C20 62.1621 3 37.3888 3 28C3 18.6111 10.6112 11 20 11C29.3888 11 37 18.6111 37 28Z"
          fill={fillColor}
        />
        <path
          d="M5.91365 29.4931C5.91365 21.3371 12.5255 14.7253 20.6815 14.7253C25.4489 14.7253 29.6878 16.9848 32.3879 20.4908C29.8378 16.0637 25.0582 13.0833 19.5823 13.0833C11.4263 13.0833 4.81445 19.6952 4.81445 27.8513C4.81445 31.2399 5.95663 34.3614 7.876 36.8535C6.6278 34.6867 5.91365 32.1733 5.91365 29.4931Z"
          fill={fillColor1}
        />
        <path
          d="M15.9902 55.66C18.3066 59.5412 19.9993 62.1621 19.9993 62.1621C19.9993 62.1621 36.9993 37.3888 36.9993 28C36.9993 27.507 36.9737 27.0202 36.9326 26.5379C36.2615 29.1462 35.3132 31.6858 34.1489 34.1095C30.9312 40.8077 26.1724 45.0995 21.104 50.5336C19.4701 52.2853 17.7694 54.0176 15.9902 55.66Z"
          fill={fillColor2}
        />
      </g>
      <rect x="27" y="1" width="22" height="22" rx="11" fill={strokeColor} />
      <rect x="27" y="1" width="22" height="22" rx="11" stroke="white" strokeWidth="2" />
      <path
        d="M34.6202 9.40625V8.27273H41.3745V9.40625H38.6515V17H37.339V9.40625H34.6202Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_ddd_6677_63891"
          x="0"
          y="9"
          width="40"
          height="57.1621"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6677_63891" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_6677_63891"
            result="effect2_dropShadow_6677_63891"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_6677_63891"
            result="effect3_dropShadow_6677_63891"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_6677_63891"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default TrainingAgentPinIcon;
